import React, { useEffect, useState } from "react";
import SchedulerTest from "../components/SchedulerTest";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

const CalendarNew = () => {
  const [isDrawOpen, setIsDrawOpen] = useState(false);

  const [formattedStart, setFormatedStart] = useState(
    moment().startOf("week").format("DD")
  );
  const [selectedDate, setSelectedDate] = useState(new Date());

  const [formattedEnd, setFormatedEnd] = useState(
    moment().endOf("week").format("DD")
  );

  const [formattedMonth, setFormatedMonth] = useState(
    moment().startOf("week").format("MMMM")
  );
  const handleNavigate = (direction) => {
    let newDate;
    if (direction === "next") {
      console.log("nesto");
      newDate = moment(selectedDate).add(1, "week").toDate();

      const startOfWeek = moment(newDate).startOf("week").format("DD");
      const endOfWeek = moment(newDate).endOf("week").format("DD");
      setFormatedStart(startOfWeek);
      setFormatedEnd(endOfWeek);
    } else if (direction === "prev") {
      newDate = moment(selectedDate).subtract(1, "week").toDate();

      const startOfWeek = moment(newDate).startOf("week").format("DD");
      const endOfWeek = moment(newDate).endOf("week").format("DD");
      setFormatedStart(startOfWeek);
      setFormatedEnd(endOfWeek);
    }
    setSelectedDate(newDate);
  };
  return (
    <div className="main-container">
      {/* <Contacts /> */}
      <div className="calendar-main-container selection">
        <div className="fake-container"></div>
        <div className="calendar-container-2">
          <SchedulerTest
            handleNavigate={handleNavigate}
            selectedDate={selectedDate}
          />
        </div>
      </div>
    </div>
  );
};

export default CalendarNew;
